import { render } from "./commessaList.vue?vue&type=template&id=2724d9d0"
import script from "./commessaList.vue?vue&type=script&lang=js"
export * from "./commessaList.vue?vue&type=script&lang=js"

import "./commessaList.vue?vue&type=style&index=0&id=2724d9d0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__